<hr class="hr1" />
<hr class="hr2" />
<div class="bottom-menu">
  <ul style="display: flex; flex-direction: row; flex-wrap: wrap">
    <li><a routerLink="/privacy">■プライバシーポリシー</a></li>
    <li><a href="https://pro.form-mailer.jp/fms/dda4888788864" target="_blank">■お問い合わせ</a></li>
  </ul>
</div>
<footer class="footer">
  <div class="footer-content">
    <div class="fcopyright">
      Copyright（C）1947 - {{ $now() | date: "yyyy" }} Nikkan Prosports Shimbunsha Inc. All rights reserved.
    </div>
    <p class="copyright-text">当サイトに掲載された全ての文章、画像について無断転載、直接リンクを禁じます。</p>
  </div>
</footer>
